module.exports = __webpack_public_path__ + "static/media/home-banner.80fce73a.png";